import { api } from "../../api";
import { RECOMMENDED_ENDPOINTS } from "../../../constants/endpoints";

export const recommendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    recommendedInit: builder.mutation({
      query: (payload) => ({
        url: RECOMMENDED_ENDPOINTS.INIT,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    getAllRecommended: builder.query({
      query: (payload) => ({
        url: RECOMMENDED_ENDPOINTS.GET_ALL,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      providesTags: ["Recommended"],
    }),
    createRecommended: builder.mutation({
      query: (payload) => ({
        url: RECOMMENDED_ENDPOINTS.CREATE,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    upsertRecommended: builder.mutation({
      query: (payload) => ({
        url: RECOMMENDED_ENDPOINTS.UPSERT,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    deleteRecommended: builder.mutation({
      query: (payload) => ({
        url: RECOMMENDED_ENDPOINTS.DELETE,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useRecommendedInitMutation,
  useGetAllRecommendedQuery,
  useCreateRecommendedMutation,
  useUpsertRecommendedMutation,
  useDeleteRecommendedMutation,
} = recommendedApi;
